import { get, post } from '../index'
export default {

  // ------------案例------------
  // 获取案列列表
  getRenovationCaseList (querys) {
    return get('/decorate/admin/AdminCase/caseList', querys)
  },
  // 添加案列
  addRenovationCaseInfo (querys) {
    return post('/decorate/admin/AdminCase/caseAdd', querys)
  },
  // 编辑案列、回显
  editRenovationCaseInfo (querys) {
    return post('/decorate/admin/AdminCase/caseUpdate', querys)
  },
  // 批量上下架、删除
  updateRenovationCaseInfo (querys) {
    return post('/decorate/admin/AdminCase/statusUpdateAll', querys)
  },

  // ----------工地------------
  // 工地列表
  getRenovationSiteList (querys) {
    return get('/decorate/admin/AdminSite/siteList', querys)
  },
  // 工地添加
  addRenovationSiteInfo (querys) {
    return post('/decorate/admin/AdminSite/siteAdd', querys)
  },
  // 工地编辑、回显
  getOrEditRenovationSiteInfo (querys) {
    return post('/decorate/admin/AdminSite/siteUpdate', querys)
  },
  // 工地上下架、删除
  updateRenovationSiteInfo (querys) {
    return post('/decorate/admin/AdminSite/statusUpdate', querys)
  },
  // 下拉框配置信息
  getRenovationSelectedOptions () {
    return post('/decorate/admin/AdminSite/siteSetting')
  },
  // 远程搜索用户
  getRenovationRemoteUser (querys) {
    return post('/decorate/admin/AdminSite/getUser', querys)
  },
  // 工地动态列表
  getRenovationSiteDyList (querys) {
    return get('/decorate/admin/AdminDynamic/dynList', querys)
  },
  // 工地动态上下架
  updateRenovationSiteDyInfo (querys) {
    return post('/decorate/admin/AdminDynamic/dynUpdate', querys)
  },

  // -----------攻略-----------
  // 攻略列表
  getRenovationStratergyList (querys) {
    return post('/decorate/admin/AdminNews/newsList', querys)
  },
  // 攻略上下架、删除、编辑、回显
  updateRenovationStrateryInfo (querys) {
    return post('/decorate/admin/AdminNews/newsUpdate', querys)
  },
  // 攻略添加
  addRenovationStrateryInfo (querys) {
    return post('/decorate/admin/AdminNews/newsAdd', querys)
  },
  // 攻略分类列表
  getRenovationStrateryClassifyList (querys) {
    return get('/decorate/admin/AdminNewsCate/cateList', querys)
  },
  // 攻略分类添加
  addRenovationStrateryClassifyInfo (querys) {
    return post('/decorate/admin/AdminNewsCate/cateAdd', querys)
  },
  // 攻略分类编辑、回显
  updateRenovationStrateryClassifyInfo (querys) {
    return post('/decorate/admin/AdminNewsCate/cateUpdate', querys)
  },
  // 文章分类下拉配置
  getRenovationClassifySelectOptions (querys) {
    return get('/decorate/admin/AdminNews/cateList')
  },

  // -----------大师团队-----------
  // 大师团队选择员工
  getRenovationMasterStaff () {
    return get('/decorate/admin/AdminMaster/selectStaff')
  },
  // 大师团队列表
  getRenovationMasterList (querys) {
    return get('/decorate/admin/AdminMaster/masterList', querys)
  },
  // 删除大师团队的信息
  delRenovationMasterInfo (querys) {
    return post('/decorate/admin/AdminMaster/masterDel', querys)
  },
  // 添加大师
  addRenovationMasterInfo (querys) {
    return post('/decorate/admin/AdminMaster/masterAdd', querys)
  },
  // 大师编辑、回显
  getOrEditRenovationMasterInfo (querys) {
    return post('/decorate/admin/AdminMaster/masterUpdate', querys)
  },

  // -----------营销管理----------
  // 智能报价列表
  getRenovationOfferList (querys) {
    return post('/decorate/admin/AdminOfferRecord/offerList', querys)
  },
  // 免费设计申请列表
  getRenovationDesignList (querys) {
    return post('/decorate/admin/AdminAppointment/appList', querys)
  },

  // -----------地区-----------
  // 地区列表
  getRenovationRegionList (querys) {
    return get('/decorate/admin/AdminArea/areaList', querys)
  },
  // 地区第一级数据
  getRenovationRegionTopList () {
    return get('/decorate/admin/AdminArea/areaOneSelect')
  },
  // 地区上下架、删除
  upDelRenovationRegionInfo (querys) {
    return post('/decorate/admin/AdminArea/statusUpdate', querys)
  },
  // 地区添加
  addRenovationRegionInfo (querys) {
    return post('/decorate/admin/AdminArea/areaAdd', querys)
  },
  // 地区编辑与回显
  editOrGetRenovationRegionInfo (querys) {
    return post('/decorate/admin/AdminArea/areaUpdate', querys)
  },

  // -------------面积-------------
  // 面积列表
  getRenovationAreaList (querys) {
    return get('/decorate/admin/AdminMeasure/mList', querys)
  },
  // 面积添加
  addRenovationAreaInfo (querys) {
    return post('/decorate/admin/AdminMeasure/mAdd', querys)
  },
  // 面积编辑、回显
  editRenovationAreaInfo (querys) {
    return post('/decorate/admin/AdminMeasure/mUpdate', querys)
  },

  // ---------------总价-------------
  // 总价列表
  getRenovationPriceList (querys) {
    return get('/decorate/admin/AdminPrice/priceList', querys)
  },
  // 价格添加
  addRenovationPriceInfo (querys) {
    return post('/decorate/admin/AdminPrice/priceAdd', querys)
  },
  // 价格编辑、回显
  editOrGetRenovationPriceInfo (querys) {
    return post('/decorate/admin/AdminPrice/priceUpdate', querys)
  },
  // 价格上下架、删除
  updateRenovationPriceInfo (querys) {
    return post('/decorate/admin/AdminPrice/changeStatus', querys)
  },

  // ---------------风格--------------
  // 风格列表
  getRenovationStyleList (querys) {
    return get('/decorate/admin/AdminStyle/styleList', querys)
  },
  // 风格添加
  addRenovationStyleInfo (querys) {
    return post('/decorate/admin/AdminStyle/styleAdd', querys)
  },
  // 风格标记
  editOrGetRenovationStyleInfo (querys) {
    return post('/decorate/admin/AdminStyle/styleUpdate', querys)
  },

  // ---------------户型-----------------
  // 户型列表
  getRenovationApartmentList (querys) {
    return post('/decorate/admin/AdminHousewear/housewearList', querys)
  },
  // 户型添加
  addRenovationApartmentInfo (querys) {
    return post('/decorate/admin/AdminHousewear/housewearAdd', querys)
  },
  // 户型编辑、回显
  editOrGetRenovationApartmentInfo (querys) {
    return post('/decorate/admin/AdminHousewear/housewearUpdate', querys)
  },

  // ---------------阶段-----------------
  // 阶段列表
  getRenovationStageList (querys) {
    return get('/decorate/admin/AdminProgress/progressList', querys)
  },
  // 阶段添加
  addRenovationStageInfo (querys) {
    return post('/decorate/admin/AdminProgress/progressAdd', querys)
  },
  // 阶段编辑
  editOrGetRenovationStageInfo (querys) {
    return post('/decorate/admin/AdminProgress/progressUpdate', querys)
  },
  // 公司简介回显
  getRenovationConfigSetting (querys) {
    return post('/decorate/admin/AdminSetting/pulgSettingInfo', querys)
  },
  // 公司简介编辑
  editRenovationConfigSetting (querys) {
    return post('/decorate/admin/AdminSetting/pulgSettingUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/renovation.js